import { apiHandler } from '@/services/apiHandler';
import type { ApiResponse } from '@/types/api';

export const getSvgData = async (url: string): Promise<ApiResponse<string>> => {
    return apiHandler(async () => {
        const response = await fetch(url);
        const data = await response.text();
        return data;
    });
};
